"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var ShopCarousel_1 = require("../components/Shop/ShopCarousel");
var targetNode = document.querySelector('.shop-carousel-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(ShopCarousel_1.default, null), targetNode);
}
